import { useMediaQueryDevice } from '@/components/MediaQuery';
import Modal from '@/components/Modal';
import WalletDrawerWrapper from '@/pages/components/WalletStatus/WalletDrawerWrapper';
import classNames from 'classnames';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useBlastWithdrawFooter } from '../useBlastWithdraw';
import BlastWithdrawFooter from './BlastWithdrawFooter';
import BlastWithdrawForm, { BlastBalanceInfo } from './BlastWithdrawForm';
import './index.less';

interface BlastWithdrawModalProps {
  open: boolean;
  onClose: () => void;
  balances: BlastBalanceInfo[];
}

const BlastWithdrawModal: FC<BlastWithdrawModalProps> = ({ open, onClose, balances }) => {
  const { isMobile } = useMediaQueryDevice();
  const { t } = useTranslation();
  const { onWithdraw, isWithdrawing } = useBlastWithdrawFooter();

  const handleLater = useCallback(() => {
    onClose();
  }, [onClose]);

  const content = (
    <div className="syn-blast-withdraw-modal-content">
      <BlastWithdrawForm balances={balances} />
      <BlastWithdrawFooter onWithdraw={onWithdraw} onLater={handleLater} isLoading={isWithdrawing} />
    </div>
  );

  if (isMobile) {
    return (
      <WalletDrawerWrapper
        className={classNames('syn-blast-withdraw-modal-drawer')}
        open={open}
        placement="bottom"
        title={t('portfolio.blastWithdrawTitle', 'Blast Withdraw')}
        destroyOnClose={true}
        onClose={onClose}
        cardProps={{
          tabList: [],
          title: t('portfolio.blastWithdrawTitle', 'Blast Withdraw'),
          showSliderBar: true,
          showSettingsIcon: false,
          children: content,
        }}
      />
    );
  }

  return (
    <Modal
      open={open}
      className={classNames('syn-blast-withdraw-modal')}
      onCancel={onClose}
      // header={header}
      width={480}
      // title={t('portfolio.blastWithdrawTitle', 'Blast Withdraw')}
      title={' '}
      closable={false}
      footer={null}>
      {content}
    </Modal>
  );
};

export default BlastWithdrawModal;
